
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "OurFleetVehiclesTemplateBlock",

  data: function () {
    return {}
  },

  computed: {
    versionBlock: function () {
      return Boolean(String(this.values?.new_version_block) === '1') ? 2 : 1;
    },

    params: function () {
      return this.externalData?.OurFleetVehiclesTemplateBlock || {}
    },

    filterList: function () {
      return this.params?.filters || []
    },
    selectedFilters: function () {
      return this.params?.selectedFilters || {}
    },

    products: function () {
      return this.params?.products || []
    },

    categoryTitle: function () {
      return this.params?.categoryTitle || (
          this.params?.category?.dynamicFields?.category_name_genitive_case ||
          this.params?.category?.name ||
          ""
      ).toLowerCase();
    },
    categoryDescription: function () {
      if (this.versionBlock === 2) {
        return null
      }
      return this.params?.category?.dynamicFields?.bottom_text || this.params?.category?.description || ""
    },

    isHideFilter: function () {
      if (this.versionBlock === 2) {
        return true;
      }
      return this.params?.isHideFilter;
    }
  },

  components: {
    MessageMore: () => import("~/components/UI/MessageMore.vue"),
    FilterComponent: () => import("./components/OurFleetVehiclesTemplateBlock/Filter"),
    ProductsComponent: () => import("./components/OurFleetVehiclesTemplateBlock/Products")
  },

  mounted: function () {
    this.scrollSectionFilter();
  },

  methods: {
    scrollSectionFilter: function () {
      if (Object.keys(this.selectedFilters || {}).length <= 0) {
        return
      }

      const headerHeight = document.getElementById('header').getBoundingClientRect().height;
      const bodyTop = this.$refs.refBody.getBoundingClientRect().top + window.pageYOffset;
      const nextScrollTop = bodyTop - headerHeight - (headerHeight / 100 * 10);
      window.scrollTo({
        top: nextScrollTop,
        behavior: "smooth"
      });
    }
  }
})
